/*
 * @Author: your name
 * @Date: 2021-05-14 16:02:59
 * @LastEditTime: 2022-04-12 13:00:42
 * @LastEditors: Smart Chow
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/modules/qc-plan/moduleDefine.js
 */
/* BasicLayout */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
import { dynamicWrapper } from '@/common/utils/routerComponentWrapper.js'

const routerComponents = {
  rulePermission: () =>
    import(
      /* webpackChunkName: "rule-permission" */ './rule-permission/index.vue'
    ),
  indicator: () =>
    import(/* webpackChunkName: "indicator" */ './indicator/index.vue'),
  indicatorType: () =>
    import(/* webpackChunkName: "indicator" */ './indicator-type/index.vue'),
  organizationTag: () =>
    import(
      /* webpackChunkName: "organizationTag" */ './organization-tag/index.vue'
    ),
  organization: () =>
    import(/* webpackChunkName: "organization" */ './organization/index.vue'),
  checkForm: () =>
    import(/* webpackChunkName: "checkForm" */ './check-form/index.vue'),
  combinationForm: () =>
    import(
      /* webpackChunkName: "combinationForm" */ './combination-form/index.vue'
    ),
  qcGroup: () =>
    import(/* webpackChunkName: "qcGroup" */ './qc-group/index.vue'),
  systemDict: () =>
    import(/* webpackChunkName: "systemDict" */ './system-dict/index.vue'),
  knowledge: () =>
    import(/* webpackChunkName: "knowledge" */ './knowledge/index.vue'),
  knowledgeCategory: () =>
    import(
      /* webpackChunkName: "knowledgeCategory" */ './knowledge-category/index.vue'
    ),
  timeControl: () =>
    import(/* webpackChunkName: "timeControl" */ './time-control/index.vue'),
  messageAdvise: () =>
    import(
      /* webpackChunkName: "messageAdvise" */ './message-advise/index.vue'
    ),
  systemConfig: () =>
    import(/* webpackChunkName: "messageAdvise" */ './system-config/index.vue'),
  pjConfig: () =>
    import(/* webpackChunkName: "messageAdvise" */ './pj-config/index.vue'),
  migration: () =>
    import(/* webpackChunkName: "migration" */ './migration/index.vue')
}

export default {
  // 模块子路由表
  routes: [
    {
      path: '/',
      component: BasicLayout,
      meta: {
        title: '系统设置',
        icon: 'chart'
      },
      children: [
        {
          path: 'User/UserYHJS',
          component: dynamicWrapper(
            ['qc-systemSetting/rule-permission'],
            routerComponents.rulePermission
          ),
          meta: { title: '角色权限', noCache: true }
        },
        {
          path: 'Settings/SettingMBSZ',
          component: dynamicWrapper(
            ['qc-systemSetting/indicator'],
            routerComponents.indicator
          ),
          meta: { title: '质控指标设置', noCache: true }
        },
        {
          path: 'Settings/SettingZBLX',
          component: dynamicWrapper(
            ['qc-systemSetting/indicator-type'],
            routerComponents.indicatorType
          ),
          meta: { title: '质控指标值类型设置', noCache: true }
        },
        {
          path: 'Settings/SettingZZJGSX',
          component: dynamicWrapper(
            ['qc-systemSetting/organization-tag'],
            routerComponents.organizationTag
          ),
          meta: { title: '组织结构属性设置', noCache: true }
        },
        {
          path: 'Settings/SettingZZJG',
          component: dynamicWrapper(
            ['qc-systemSetting/organization'],
            routerComponents.organization
          ),
          meta: { title: '组织结构设置', noCache: true }
        },
        {
          path: 'Form/FormMan',
          component: dynamicWrapper(
            ['qc-systemSetting/check-form'],
            routerComponents.checkForm
          ),
          meta: { title: '检查表单设置', noCache: true }
        },
        {
          path: 'Settings/SettingZHB',
          component: dynamicWrapper(
            ['qc-systemSetting/combination-form'],
            routerComponents.combinationForm
          ),
          meta: { title: '组合表设置', noCache: true }
        },
        {
          path: 'Settings/SettingZKZ',
          component: dynamicWrapper(
            ['qc-systemSetting/qc-group'],
            routerComponents.qcGroup
          ),
          meta: { title: '质控组设置', noCache: true }
        },
        {
          path: 'Settings/SettingXTMJ',
          component: dynamicWrapper(
            ['qc-systemSetting/system-dict'],
            routerComponents.systemDict
          ),
          meta: { title: '数据字典设置', noCache: true }
        },
        {
          path: 'ZSK/SettingZSK',
          component: dynamicWrapper(
            ['qc-systemSetting/knowledge'],
            routerComponents.knowledge
          ),
          meta: { title: '知识库设置', noCache: true }
        },
        {
          path: 'ZSK/ZSKLX',
          component: dynamicWrapper(
            ['qc-systemSetting/knowledge-category'],
            routerComponents.knowledgeCategory
          ),
          meta: { title: '知识库类型', noCache: true }
        },
        {
          path: 'Settings/timeControl',
          component: dynamicWrapper(
            ['qc-systemSetting/time-control'],
            routerComponents.timeControl
          ),
          meta: { title: '时效控制设置', noCache: true }
        },
        {
          path: 'Settings/messageAdvise',
          component: dynamicWrapper(
            ['qc-systemSetting/message-advise'],
            routerComponents.messageAdvise
          ),
          meta: { title: '消息通知设置', noCache: true }
        },
        {
          path: 'Settings/SystemConfig',
          component: dynamicWrapper(
            ['qc-systemSetting/system-config'],
            routerComponents.systemConfig
          ),
          meta: { title: '系统配置', noCache: true }
        },
        {
          path: 'Settings/pjConfig',
          component: dynamicWrapper(
            ['qc-systemSetting/pj-config'],
            routerComponents.pjConfig
          ),
          meta: { title: '评价流程配置', noCache: true }
        },
        {
          path: 'Settings/Migration',
          component: dynamicWrapper(
            ['qc-systemSetting/migration'],
            routerComponents.migration
          ),
          meta: { title: '任务迁移', noCache: true }
        }
      ]
    }
  ]
}
